<template>
	<v-dialog v-model="dialog" persistent max-width="500">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">回答の編集</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="py-2">
				<p v-if="answer.user_id != user.id" class="red--text">他の人が作成した回答です</p>
				<p v-if="answer.status_id != 'draft'" class="red--text">
					この回答は既に発行済みです。<br />必要に応じて更新前に関係者と調整を行い、更新後に関係者に別途連絡を入れてください。<br />更新後に履歴が作成されます。
				</p>
				<v-divider class="my-2" v-if="answer.status_id != 'draft'" />
				<div class="d-flex">
					<p>現在の値：</p>
					<p
						v-if="answer"
						class="pre-wrap"
						v-text="`${answer[dataKey] ? answer[dataKey] : ''}`"
					></p>
				</div>
			</v-card-text>
			<v-form v-model="valid">
				<v-card-actions>
					<v-text-field
						v-if="dataType == 'date'"
						label="希望納期"
						dense
						outlined
						:rules="[rules.required]"
						class="mt-4"
						hint="依頼の希望納期を記入してください"
						v-model="newAnswer[dataKey]"
					/>

					<v-textarea
						v-if="dataType == 'text'"
						class="mt-4"
						:label="label"
						:rules="[]"
						outlined
						dense
						v-model="newAnswer[dataKey]"
					/>

					<v-text-field
						v-if="dataType == 'date'"
						:label="label"
						type="date"
						dense
						outlined
						:rules="[rules.required]"
						class="mt-4"
						v-model="newAnswer[dataKey]"
					/>
				</v-card-actions>
				<v-card-actions>
					<v-textarea
						class="mt-4"
						label="変更理由"
						:rules="[rules.required]"
						outlined
						dense
						v-model="reason"
						v-if="answer.status_id != 'draft'"
					/>
				</v-card-actions>
				<v-card-actions>
					<v-row no-gutters>
						<v-col cols="4" />
						<v-col cols="4">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="updateAnswer" :disabled="!valid">
									<v-icon class="mr-2">mdi-arrow-up-bold-box-outline</v-icon>
									更新する
								</v-btn>
							</v-row>
						</v-col>

						<v-col cols="4">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
export default {
	data() {
		return {
			common: common,
			dialog: false,
			valid: false,
			rules: rules,
			answer: { status_id: "", user_id: "", id: "", answer_fixes: [] },
			label: "",
			dataType: "",
			dataKey: "",
			newAnswer: Object,
			showIndex: Number,
			reason: "",
			user: {},
		}
	},
	methods: {
		setEditData(dataSet) {
			// 親から呼ぶメソッド
			this.answer = dataSet.answer
			this.label = dataSet.label
			this.dataType = dataSet.dataType
			this.dataKey = dataSet.dataKey
			this.user = dataSet.user
			this.dialog = true
			if (dataSet.dataKey == "message") {
				this.newAnswer.message = this.answer.message
			}
			console.log(this.answer)
		},
		closeDialog() {
			this.dialog = false
		},
		choiceUpdate() {
			if (this.answer.status_id == "draft") {
				this.updateAnswer()
			} else {
				this.createAnswerFix()
			}
		},
		createAnswerFix() {
			console.log("fixで更新")
			if (this.answer.status_id != "draft" && this.reason == "") {
				this.$store.dispatch("setFlash", {
					text: "理由は必須です",
					type: "alert",
				})
				return
			}
			const headers = authenticate.setHeader()
			axios
				.post(
					"/erp/v1/answers/fixes",
					{
						answer_id: this.answer.id,
						changed_column: [this.dataKey],
						fix: {
							reason: this.reason,
							changed_column: this.dataKey,
						},
						answer: {
							[this.dataKey]: this.newAnswer[this.dataKey],
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
					// this.answer = res.data.answer
					this.reason = ""
					this.dialog = false
					this.$emit("updateAnswer", this.answer, this.showIndex)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateAnswer() {
			if (this.answer.status_id != "draft" && this.reason == "") {
				this.$store.dispatch("setFlash", {
					text: "理由は必須です",
					type: "alert",
				})
				return
			}
			const headers = authenticate.setHeader()
			let changed_column = this.dataKey
			axios
				.put(
					`/erp/v1/answers/${this.answer.id}`,
					{
						answer_id: this.answer.id,
						changed_column: changed_column,
						fix: {
							reason: this.reason,
							changed_column: changed_column,
						},
						answer: {
							[this.dataKey]: this.newAnswer[this.dataKey],
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
					this.dialog = false
					this.reason = ""
					this.$emit("update-answer", {
						changed_column,
						data: res.data.answer,
						fix: res.data.answer_fix,
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		dataType() {
			if (this.dataType == "matter_product") {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/matter_products.json", {
						headers,
						params: {
							matter_id: this.answer.matter_id,
						},
					})
					.then((response) => {
						this.targetList = response.data.matter_products
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			} else if (this.dataType == "ordered_product") {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/matter_ordered_products.json", {
						headers,
						params: {
							matter_id: this.answer.matter_id,
						},
					})
					.then((response) => {
						this.targetList = response.data.ordered_products
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			} else if (this.dataType == "order_individual_info") {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/order_individual_infos.json", {
						headers,
						params: {
							op_id: this.answer.ordered_product_id,
						},
					})
					.then((response) => {
						this.targetList = response.data.individual_infos
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			}
		},
	},
}
</script>
<style scoped>
.w100 {
	width: 100%;
}
</style>
